import React, { useState } from 'react';
import MetricCard from './MetricCard';

const HubLayout = ({ 
  icon, 
  title, 
  subtitle, 
  metrics = [], 
  tabs = [], 
  defaultTab,
  activeTab: externalActiveTab,
  onTabChange,
  actions,
  children 
}) => {
  // Use external state if provided, otherwise use internal state
  const [internalActiveTab, setInternalActiveTab] = useState(defaultTab || (tabs.length > 0 ? tabs[0].id : null));
  
  // Determine which activeTab to use (external prop takes precedence)
  const activeTab = externalActiveTab !== undefined ? externalActiveTab : internalActiveTab;
  
  // Handle tab change - call external handler if provided, otherwise use internal state
  const handleTabChange = (tabId) => {
    if (onTabChange) {
      onTabChange(tabId);
    } else {
      setInternalActiveTab(tabId);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 px-6 pt-3 pb-6">
      {/* Header */}
      <div className="mb-4">
        <div className="flex items-center justify-between mb-2">
          <div>
            {/* Icon removed, title reduced */}
            <h1 className="text-lg font-bold text-white">{title}</h1>
            <p className="text-xs text-gray-400">{subtitle}</p>
          </div>
          
          {actions && (
            <div className="flex gap-2">
              {actions}
            </div>
          )}
        </div>
      </div>

      {/* Metrics Bar */}
      {metrics.length > 0 && (
        <div className="flex flex-wrap gap-3 mb-3">
          {metrics.map((metric, index) => (
            <MetricCard key={index} {...metric} />
          ))}
        </div>
      )}

      {/* Tabs - Compact */}
      {tabs.length > 0 && (
        <div className="border-b border-gray-700 mb-2">
          <div className="flex gap-1">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => handleTabChange(tab.id)}
                className={`flex items-center gap-1 px-2 py-1.5 text-[11px] font-medium border-b-2 transition-colors ${
                  activeTab === tab.id
                    ? 'border-blue-500 text-blue-400'
                    : 'border-transparent text-gray-400 hover:text-gray-300'
                }`}
              >
                {tab.icon && <span className="text-xs">{tab.icon}</span>}
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Content */}
      <div className="mt-2">
        {typeof children === 'function' ? children(activeTab) : children}
      </div>
    </div>
  );
};

export default HubLayout;
